<ng-container
  *ngIf="{
    collapseList: collapseList$ | async,
  } as content"
>
  @if (content.collapseList) {
    <collapse-list [collapseList]="content.collapseList"></collapse-list>
  }
</ng-container>
